import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { CheckIcon, ShareIcon } from 'lucide-react'
import { shareAccommodation } from './shareAccommodation'

interface DetailShareButtonProps {
  name: string
}

export function DetailShareButton({ name }: DetailShareButtonProps) {
  const [copied, setCopied] = useState(false)

  return (
    <button
      onClick={() => {
        shareAccommodation(name)
          .then((result) => {
            if (result === 'copied') {
              setCopied(true)
              setTimeout(() => setCopied(false), 2000)
            }
          })
          .catch((error: unknown) => {
            Sentry.captureException(error)
          })
      }}
      className="text-red inline-flex cursor-pointer items-center gap-1.5 underline"
    >
      {copied ? <CheckIcon className="h-5 w-5" /> : <ShareIcon className="h-5 w-5" />}
      {copied ? 'Odkaz zkopírován' : 'Sdílet'}
    </button>
  )
}
